import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-alert-stats',
    templateUrl: './alert-stats.component.svg',
    styleUrls: ['./alert-stats.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertStatsComponent {}
